import type { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ManageMasterWageFiltersService } from '../../master-wage-filters/services/manage-master-wage-filters.service';
import { FilterStatus } from '../../master-wage-filters/interfaces/filter-status.enum';

export const clearFilterDataOnExitGuard: CanDeactivateFn<boolean> = () => {
  const _storageService = inject(StorageService);
  const _manageWageFilters = inject(ManageMasterWageFiltersService);

  _storageService.remove('filterDeterminationState');

  _manageWageFilters.setNewFilterPropertiesContext({
    ..._manageWageFilters.getFilterPropertiesContextValue(),
    buttonStatus: FilterStatus.disable,
    isFilteringWageLocation: false,
    expandFiltersPanels: false,
    isExpandingOrCollapsingAllFilter: false,
    isDeterminationModificationFilterDisabled: true,
    isFilterDisabled: true,
    selectedAuthorizedJurisdiction: {},
    selectedIdJurisdiction: '',
    statusApplyFiltersButton: true,
    wageDeterminationModification: {},
    authorizedJurisdictionLocation: {},
    wageLocation: {},
    whereClause: {},
  });
  _manageWageFilters.setNewSelectedIdsForWageDeterminationPanelFilter([]);
  _manageWageFilters.setNewWageDeterminationsWhereClauseParameters([]);

  return true;
};
